import { render, staticRenderFns } from "./GoToView.vue?vue&type=template&id=b4d4be40&"
import script from "./GoToView.vue?vue&type=script&lang=js&"
export * from "./GoToView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports